export const DEFAULT_ADYEN_COUNTRY_CODE = "US";

export const withAdyenCountryCode = (configuration = {}) => ({
  ...configuration,
  countryCode: String(
    configuration.countryCode || DEFAULT_ADYEN_COUNTRY_CODE,
  ).toUpperCase(),
});
